import { render, staticRenderFns } from "./HelpItemDetails.vue?vue&type=template&id=fe05a6e2&scoped=true&"
import script from "./HelpItemDetails.vue?vue&type=script&lang=js&"
export * from "./HelpItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./HelpItemDetails.vue?vue&type=style&index=0&id=fe05a6e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe05a6e2",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QBtnGroup});
